import tippy from 'tippy.js';

export default class TooltipManager {
  tippyInstances;
  targetSelector;
  templateId;
  templateHtml;

  constructor(targetSelector, templateId) {
    this.targetSelector = targetSelector;
    this.templateId = templateId;
    this.templateHtml = document.getElementById(templateId).innerHTML;
  }

  terminate() {
    this.tippyInstances?.forEach((instance) => instance.disable());
  }

  reload() {
    this.terminate();
    this.launch();
  }

  launch() {
    this.tippyInstances = tippy(this.targetSelector, {
      content: this.templateHtml,
      allowHTML: true,
      arrow: true,
      trigger: 'click',
      maxWidth: 249,
      placement: 'top-end',
      delay: 0,
      animation: 'shift-away-subtle',
      theme: 'light',
    });
  }
}
